<div>
     <p class="textStyle">Se gestionará la devolución del dinero de todas las reservas anuladas antes de las 20:00 horas del día anterior a la consultas.</p>
     <p class="textStyle">Cualquier consulta anulada posterior a dicho horario no tendrán devolución del dinero.</p>
     <p class="textStyle">Para solicitar, gestionar o consultar por el estado de su devolución, por favor escribenos a <span style="font-weight:bold;">devoluciones@almamedis.cl</span></p>
</div>